// src/components/Navbar.jsx
import { useState, useEffect, useRef } from "react";

export default function Navbar({ page, setPage }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const btnRef = useRef(null);
  const isHome = page === "home";

  useEffect(() => {
    function onClickOutside(e) {
      if (!open) return;
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    }
    function onEsc(e) { if (e.key === "Escape") setOpen(false); }
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onEsc);
    };
  }, [open]);

  const NavButton = ({ active, onClick, children }) => (
    <button
      onClick={() => { onClick?.(); setOpen(false); }}
      className={[
        "rounded-full px-4 py-2 w-full sm:w-auto text-left sm:text-center transition",
        isHome
          ? (active
              ? "bg-white/15 text-white shadow-brand ring-1 ring-white/30"
              : "bg-transparent text-white/90 hover:text-white border border-white/30 hover:border-white/50")
          : (active
              ? "bg-manupro-primary text-white shadow-brand ring-1 ring-manupro-ring/60"
              : "bg-white/80 text-[#2a2306] hover:bg-white border border-white/70 backdrop-blur")
      ].join(" ")}
    >
      {children}
    </button>
  );

  return (
    <header
      className={[
        isHome
          ? // HOME: absolut, transparent, FĂRĂ border/shadow
            "absolute top-0 left-0 right-0 z-30 bg-transparent border-0 shadow-none"
          : // ALTE PAGINI: bară solidă
            "sticky top-0 z-20 bg-[#2a2306] text-white"
      ].join(" ")}
    >
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center">
        {/* Brand */}
        <button
          onClick={() => {
            setPage?.("home");
            if (typeof window !== "undefined") {
              const base = window.location.pathname + window.location.search;
              if (window.location.hash) window.history.replaceState({}, "", base);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }}
          onMouseUp={(e) => e.currentTarget.blur()}
          aria-label="Manu Pro Detailing"
          className="group flex items-center gap-3 cursor-pointer select-none bg-transparent"
        >
          <img
            src="/logo.png"
            alt="Manu Pro Detailing"
            className="h-10 w-auto sm:h-12 md:h-14 transition group-hover:brightness-110"
            loading="eager"
            decoding="async"
          />
          <span className={["text-xl sm:text-2xl md:text-3xl font-semibold leading-none transition group-hover:opacity-90",
            isHome ? "text-white" : "text-white"].join(" ")}>
            Manu <span className="text-manupro-primary">Pro</span> Detailing
          </span>
        </button>

        {/* Right group */}
        <div className="ml-auto flex items-center gap-2">
          <nav className="hidden sm:flex items-center gap-2" role="navigation" aria-label="Primary">
            <NavButton active={page === "home"} onClick={() => setPage("home")}>Acasă</NavButton>
            <NavButton
              active={page === "gallery"}
              onClick={() => {
                setPage("gallery");
                if (typeof window !== "undefined" && window.location.hash !== "#gallery") {
                  window.location.hash = "#gallery";
                }
              }}
            >
              Galerie
            </NavButton>
          </nav>

          {/* Mobile hamburger */}
          <button
            ref={btnRef}
            onClick={() => setOpen((v) => !v)}
            className={["sm:hidden rounded-xl p-2",
              isHome ? "text-white hover:bg-white/10" : "text-white hover:bg-white/10"].join(" ")}
            aria-label="Deschide meniul"
            aria-expanded={open}
            aria-controls="mobile-menu"
          >
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true">
              {open ? (
                <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile dropdown (translucid pe home, fără border) */}
      <div
        id="mobile-menu"
        ref={menuRef}
        className={[
          "sm:hidden overflow-hidden transition-[max-height] duration-300",
          open ? "max-h-96" : "max-h-0",
          isHome ? "bg-black/30 backdrop-blur" : "bg-[#2a2306]"
        ].join(" ")}
      >
        <div className="px-4 py-3 flex flex-col gap-2">
          <NavButton active={page === "home"} onClick={() => setPage("home")}>Acasă</NavButton>
          <NavButton
            active={page === "gallery"}
            onClick={() => {
              setPage("gallery");
              if (typeof window !== "undefined" && window.location.hash !== "#gallery") {
                window.location.hash = "#gallery";
              }
            }}
          >
            Galerie
          </NavButton>
        </div>
      </div>
    </header>
  );
}
